<template>
  <div class="bg-white">
    <h4 class="font-black uppercase text-xl xl:text-above-h2 leading-56px tracking-lg mb-15">
      <span>{{ $t('News & Press') }}</span>
    </h4>
    <div class="-ml-sm -mr-sm clearfix">
      <div
        class="w-1/2 px-sm float-left"
        v-for="(image, index) in brand.newsPressImages"
        :key="index"
      >
        <img :src="image" alt="News And Press">
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'NewsPress',
  props: {
    brand: {
      type: Object,
      required: true,
      default: () => {}
    }
  }
}
</script>
